"use client";

import { useAuthUser } from "@/hooks/auth.hook";
import { ymd } from "@/services/reservations.service";
import { useLocale } from "next-intl";
import { useRouter } from "next/navigation";
import { useState } from "react";

/**
 * "Go to checkout with these dates" — shared by the unit page, its mobile
 * booking bar and the "اختر" button on unit cards. Not logged in → login first.
 */
export function useReserve() {
  const locale = useLocale();
  const router = useRouter();
  const { data: user } = useAuthUser();
  const [showLogin, setShowLogin] = useState(false);

  const reserve = (propertyId: string, { checkIn, checkOut, guests }: { checkIn: Date; checkOut: Date; guests: number }) => {
    if (!user) {
      setShowLogin(true);
      return;
    }
    const qs = new URLSearchParams({
      type: "reservation",
      propertyId,
      checkIn: ymd(checkIn),
      checkOut: ymd(checkOut),
      adults: String(guests),
    });
    router.push(`/${locale}/checkout?${qs.toString()}`);
  };

  return { reserve, showLogin, setShowLogin };
}
